import {NgModule} from '@angular/core';
import {RouterModule, Routes, PreloadAllModules} from '@angular/router';

import {FullLayoutComponent} from './layouts/full/full-layout.component';
import {ContentLayoutComponent} from './layouts/content/content-layout.component';

import {Full_ROUTES} from './shared/routes/full-layout.routes';
import {CONTENT_ROUTES} from './shared/routes/content-layout.routes';

import {AuthGuard} from './shared/auth/auth-guard.service';
import {MenuResolver} from './services/menu.resolver';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'login-admin',
    pathMatch: 'full',
  },
  {
    path: '', component: FullLayoutComponent, canActivate: [AuthGuard], // ✅ Add your guard here
    data: {title: 'full Views'}, children: Full_ROUTES, resolve: {menus: MenuResolver}
  },
  {path: '', component: ContentLayoutComponent, data: {title: 'content Views'}, children: CONTENT_ROUTES},
  {
    path: '**',
    redirectTo: 'error'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, {preloadingStrategy: PreloadAllModules})],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
